import { render, staticRenderFns } from "./DashboardBalance.vue?vue&type=template&id=d6e6a272"
import script from "./DashboardBalance.vue?vue&type=script&lang=js"
export * from "./DashboardBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports